// Structure du cours "Tempalte"
import courseImage from './course-image.jpg';

export const courseStructure = {
  id: 'flappybird',
  title: 'Jeu 3 : Flappy Bird',
  image: courseImage,
  chapters: [
    {
      id: 'introduction',
      title: 'Introduction',
      path: '/cours/flappybird'
    },
    {
      id: 'chapitre1',
      title: 'Squelette et image de fond',
      path: '/cours/flappybird/chapitre1'
    },
    {
      id: 'chapitre2',
      title: 'Tuyaux haut et bas',
      path: '/cours/flappybird/chapitre2'
    },
    {
      id: 'chapitre3',
      title: 'Déplacement des tuyaux',
      path: '/cours/flappybird/chapitre3'
    },
    {
      id: 'chapitre4',
      title: 'Ajout de tuyaux',
      path: '/cours/flappybird/chapitre4'
    },
    {
      id: 'chapitre5',
      title: 'L\'oiseau',
      path: '/cours/flappybird/chapitre5'
    },
    {
      id: 'chapitre6',
      title: 'Le score',
      path: '/cours/flappybird/chapitre6'
    },
    {
      id: 'chapitre7',
      title: 'Les collisions',
      path: '/cours/flappybird/chapitre7'
    },
    {
      id: 'chapitre8',
      title: 'Ecran de fin',
      path: '/cours/flappybird/chapitre8'
    },
    {
      id: 'chapitre9',
      title: 'Son et équilibrage',
      path: '/cours/flappybird/chapitre9'
    }
   
  ]
}; 